import type { PropsWithChildren } from 'react'

import { IconButton } from '../../actions/iconButton/IconButton'

type Props = {
  onNext: () => void
  onPrevious: () => void
  previewIndex: number
  count: number
  isActive: boolean
}

export const SearchResultPreview = ({
  previewIndex,
  onNext,
  onPrevious,
  count,
  children,
}: PropsWithChildren<Props>) => (
  <div className="flex h-full flex-col">
    <div className="min-h-0 grow overflow-hidden">{children}</div>
    <div className="flex items-center justify-end gap-x-1 pt-1">
      <div className="opacity-50">{`${previewIndex + 1} / ${count}`}</div>
      <IconButton onClick={onPrevious} iconName="ChevronLeft" />
      <IconButton onClick={onNext} iconName="ChevronRight" />
    </div>
  </div>
)
